import React from 'react';

import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';

import ConnectionErrorHandler from '../components/ConnectionError/ConnectionErrorHandler';
import ConnectionPageDesktop from './components/ConnectionInProgress/ConnectionPageDesktop';
import ConnectionPageMobile from './components/ConnectionInProgress/ConnectionPageMobile';
import QuickStartGuidePopup from './components/QuickStartGuidePopup/QuickStartGuidePopup';
import {ConnectionProvider} from './ConnectionContext';
import useConnectionPage from './hooks/useConnectionPage';

const ConnectionPageWithContext = () => {
    const isMobile = useIsMobileLayout();
    const {deviceType, currentStep, steps, isConnectionFinished, isQsgOpened, handleQsgOpen} = useConnectionPage();
    const openQsg = () => handleQsgOpen(true);
    const closeQsg = () => handleQsgOpen(false);

    return (
        <>
            {isMobile ? (
                <ConnectionPageMobile
                    currentStep={currentStep}
                    steps={steps}
                    isConnectionFinished={isConnectionFinished}
                    onOpenQsg={openQsg}
                    deviceType={deviceType}
                />
            ) : (
                <ConnectionPageDesktop
                    currentStep={currentStep}
                    steps={steps}
                    isConnectionFinished={isConnectionFinished}
                    onOpenQsg={openQsg}
                    deviceType={deviceType}
                />
            )}
            {isQsgOpened && <QuickStartGuidePopup onClose={closeQsg} deviceType={deviceType} />}
            <ConnectionErrorHandler deviceType={deviceType} />
        </>
    );
};

const ConnectionPage = () => {
    return (
        <ConnectionProvider>
            <ConnectionPageWithContext />
        </ConnectionProvider>
    );
};

export default ConnectionPage;
